export enum langs {
    ru = 'ru',
    en = 'en',
}
